// Module
var code = "<p>The typography options allows you to change the font of your survey.</p> <p>Choose a font that is best suited to match the intended look and feel of your survey.</p> ";
// Exports
module.exports = code;